const polarPoint = (cx, cy, r, angleDeg) => {
  const rad = ((angleDeg - 90) * Math.PI) / 180;
  return [cx + r * Math.cos(rad), cy + r * Math.sin(rad)];
};

const starburstPath = (cx, cy, outerR, innerR, points) => {
  const step = 360 / (points * 2);
  let d = "";
  for (let i = 0; i < points * 2; i++) {
    const r = i % 2 === 0 ? outerR : innerR;
    const [x, y] = polarPoint(cx, cy, r, i * step);
    d += `${i === 0 ? "M" : "L"} ${x.toFixed(2)},${y.toFixed(2)} `;
  }
  return d + "Z";
};

const arcPath = (cx, cy, r, startAngle, endAngle) => {
  const [x1, y1] = polarPoint(cx, cy, r, startAngle);
  const [x2, y2] = polarPoint(cx, cy, r, endAngle);
  return `M ${x1.toFixed(2)},${y1.toFixed(2)} A ${r},${r} 0 0,1 ${x2.toFixed(2)},${y2.toFixed(2)}`;
};

const CertSeal = ({ code, size = 96 }) => {
  const id = `seal-${code}`;
  const cx = 100;
  const cy = 100;

  return (
    <svg
      viewBox="0 0 200 200"
      width={size}
      height={size}
      role="img"
      aria-label={`ISO ${code} certified seal`}
    >
      <defs>
        <linearGradient id={`${id}-gold`} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#f6e0a4" />
          <stop offset="45%" stopColor="#d9ab4f" />
          <stop offset="100%" stopColor="#b9862f" />
        </linearGradient>
      </defs>

      {/* starburst */}
      <path
        d={starburstPath(cx, cy, 96, 82, 32)}
        fill={`url(#${id}-gold)`}
        stroke="#8a6420"
        strokeWidth="1"
      />
      {/* rings */}
      <circle cx={cx} cy={cy} r="80" fill="none" stroke="#8a6420" strokeWidth="1.5" />
      <circle cx={cx} cy={cy} r="74" fill="#f3e3b8" stroke="#8a6420" strokeWidth="1" />
      <circle cx={cx} cy={cy} r="68" fill="none" stroke="#8a6420" strokeWidth="0.75" />

      {/* curved CERTIFIED labels */}
      <path id={`${id}-top`} d={arcPath(cx, cy, 71, 215, 325)} fill="none" />
      <path id={`${id}-bottom`} d={arcPath(cx, cy, 71, 35, 145)} fill="none" />
      <text fontSize="9.5" fontWeight="700" letterSpacing="1.5" fill="#4a3413">
        <textPath href={`#${id}-top`} startOffset="50%" textAnchor="middle">
          CERTIFIED
        </textPath>
      </text>
      <text fontSize="9.5" fontWeight="700" letterSpacing="1.5" fill="#4a3413">
        <textPath href={`#${id}-bottom`} startOffset="50%" textAnchor="middle">
          CERTIFIED
        </textPath>
      </text>

      {/* center rules + ISO code */}
      <line x1="55" y1="88" x2="145" y2="88" stroke="#4a3413" strokeWidth="1.5" />
      <line x1="55" y1="91" x2="145" y2="91" stroke="#4a3413" strokeWidth="0.75" />
      <text
        x="100"
        y="112"
        textAnchor="middle"
        fontSize="15"
        fontWeight="800"
        letterSpacing="1"
        fill="#3a2a10"
      >
        ISO {code}
      </text>
      <line x1="55" y1="120" x2="145" y2="120" stroke="#4a3413" strokeWidth="0.75" />
      <line x1="55" y1="123" x2="145" y2="123" stroke="#4a3413" strokeWidth="1.5" />
    </svg>
  );
};

export default CertSeal;
